module.exports = __webpack_public_path__ + "img/delivery-truck.d7d34c5b.svg";